import Request from '@request'
import api from '@api'

export default {}
